module.exports = __webpack_public_path__ + "static/img/bak3.3d855f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/ing1/bak3.png
// module id = HRCI
// module chunks = 0